import { Box, Container, Flex } from '@energiebespaarders/symbols';
import styled from 'styled-components';
import theme from '~/styles/theme';
import type { fetchCategoryAndTopicBySlug_allFaqCategories } from '~/types/generated/cms/fetchCategoryAndTopicBySlug';
import type { getCategories_allFaqCategories } from '~/types/generated/cms/getCategories';
import type { getFaqItemsByCategory_allFaqItems } from '~/types/generated/cms/getFaqItemsByCategory';
import DatoMetaTags from '../DatoCms/DatoMetaTags';
import HybridLink from '../HybridLink';
import CategoryOverview from './CategoryOverview';
import type { FAQSubCategory } from './Category';

export const Clickable = styled.div`
  cursor: pointer;
`;

export const StyledLink = styled(HybridLink)`
  color: black;
`;

export interface ParentCategoryPageProps {
  type: 'parentCategory';
  parentCategory: fetchCategoryAndTopicBySlug_allFaqCategories;
  subCategories: FAQSubCategory[];
  readonly navbarCategories: ReadonlyArray<getCategories_allFaqCategories>;
  faqItems: ReadonlyArray<getFaqItemsByCategory_allFaqItems>;
}

type Props = Omit<ParentCategoryPageProps, 'type' | 'navbarCategories'>;

const ParentCategory: React.FC<Props> = ({ parentCategory, subCategories, faqItems }) => {
  const canonicalUrl = `https://energiebespaarders.nl/faq/${parentCategory.slug}`;

  return (
    <>
      <DatoMetaTags metaTags={parentCategory.seo} canonicalUrl={canonicalUrl} />
      <Container size="lg" py={10}>
        <Box p={[4, 4, 4, 0]} display="flex" flexDirection="column">
          <Box mb={2}>
            <h1>{parentCategory.title}</h1>
            <Box style={{ fontSize: theme.type.scale[3] }}>{parentCategory.subHeading}</Box>
          </Box>

          <Flex flexWrap="wrap" mx={-2} mb={4}>
            {subCategories.map((c, i) => {
              return (
                <Flex
                  alignItems="center"
                  py={2}
                  width={[1, 1, 1 / 2, 1 / 2]}
                  px={2}
                  key={'subCategory-' + i}
                  style={{ fontSize: theme.type.scale[3], fontWeight: 500 }}
                >
                  <StyledLink to={`/faq/${parentCategory.slug}/${c.category.slug}`}>
                    {c.category.title}
                  </StyledLink>
                </Flex>
              );
            })}
          </Flex>

          {subCategories.map(c => (
            <CategoryOverview
              key={c.category.id}
              category={c.category}
              topics={c.topics}
              faqItems={faqItems}
              isInParentCategory
            />
          ))}
        </Box>
      </Container>
    </>
  );
};

export default ParentCategory;

export const TopicContainer = styled.div`
  width: ${(p: { width: string }) => p.width};
  height: 80px;
  font-weight: 600;
  font-size: 21px;
`;
